import { Injectable, inject } from '@angular/core';

import { FixtureViewType } from '@cds/betting-offer';
import { EventParticipant } from '@frontend/sports/betting-offer/feature/model';
import { ShortNameModule, ShortTeamNamesService } from '@frontend/sports/betting-offer/feature/short-team-names';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { PropType } from '@frontend/sports/common/core/utils/extended-types';

export interface BetBuilderEventNameOptions {
    eventName: string;
    participants: EventParticipant[];
    eventViewType?: FixtureViewType;
    leagueId: number;
    sportId: number;
}

@Injectable({ providedIn: 'root' })
export class BetBuilderEventNameService {
    sitecore = inject(Sitecore);
    private shortTeamNamesService = inject(ShortTeamNamesService);

    private betBuilderMessages: PropType<PropType<Sitecore, 'betBuilderEntainUI'>, 'messages'>;

    constructor() {
        const sitecore = this.sitecore;

        this.betBuilderMessages = sitecore.betBuilderEntainUI.messages;
    }

    getParticipantHeaderTitle({ eventName, participants, eventViewType, leagueId, sportId }: BetBuilderEventNameOptions): string {
        if (participants?.length) {
            const [first, second] = participants;
            if (first && second) {
                const firstName = this.getParticipantName(first, leagueId, sportId);
                const secondName = this.getParticipantName(second, leagueId, sportId);
                const divider = eventViewType === FixtureViewType.American ? this.betBuilderMessages?.ParticipantNamesDivider : '-';

                return `${firstName} ${divider} ${secondName}`;
            }
        }

        return eventName;
    }

    private getParticipantName(participant: EventParticipant, leagueId: number, sportId: number): string {
        if (!participant) {
            return '';
        }

        if (this.shortTeamNamesService.shouldUseShortName(participant, sportId, leagueId, ShortNameModule.Grids)) {
            const name = participant.shortName!;

            return this.shortTeamNamesService.clearShortName(name);
        }

        return participant.name;
    }
}
